import Vue from "vue";
import VueSimpleAlert from "vue-simple-alert";
 
Vue.use(VueSimpleAlert);